import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { subDays } from 'date-fns';

const requiredField = 'Campo obrigatório';
const positiveValue = 'Passe um valor positivo';

export const voucherValidation = () =>
  yupResolver(
    Yup.object().shape({
      type: Yup.string().required(requiredField),
      description: Yup.string().required(requiredField),
      name: Yup.string()
        .required(requiredField)
        .matches(
          /^[A-Za-z0-9]{0,20}$/,
          'Cupom deve conter apenas letras e números'
        ),
      value: Yup.number()
        .typeError('Valor deve ser um número')
        .positive(positiveValue)
        .required(requiredField)
        .when('type', (type, field) =>
          type === 'fixed'
            ? field.max(99.99, 'Limite máximo atingido')
            : field.max(100, 'Limite máximo atigindo')
        ),
      quantity: Yup.number()
        .typeError('Valor deve ser um número')
        .when('limited', (limited, field) =>
          limited
            ? field
                .required(requiredField)
                .integer('Deve ser um número inteiro')
                .positive(positiveValue)
            : field
        ),
      expireAt: Yup.date()
        .nullable()
        .typeError('Data inválida')
        .when('dateLimited', (dateLimited, field) =>
          dateLimited
            ? field
                .required(requiredField)
                .min(subDays(new Date(), 1), 'Não pode ser data que já passou')
            : field
        ),
      forever: Yup.boolean(),
    })
  );

